// Single source of the EIB silent-blast decision, shared by FlightForm (inline
// schedule guard + warning) and PreSendConfirmationModal (the authoritative
// Send Now / Schedule gate). Keeping it in ONE tested place prevents the two
// surfaces from drifting on a rule that gates a mass send.
//
// The send path (send-campaign-flight) populates {{invite_link}} for an EIB invite
// bound to a published landing page: a personalized TOKENIZED link when
// registration_mode === 'invite_gated', or the same UNGATED /register/<id> link when
// registration_mode === 'open' (anyone-with-the-link — the send path injects it for
// open mode too). In any OTHER context it renders {{invite_link}} EMPTY to the whole
// audience — and {{invite_link}} has no fallback (unlike {{landing_page_link}}). So the
// guard must permit invite_gated AND open, and block the rest.

/** Does the selected template reference {{invite_link}} (case-insensitive)? */
export function templateUsesInviteLink(
  mergeFields: string[] | null | undefined,
): boolean {
  if (!mergeFields) {
    return false;
  }
  return mergeFields.some((f) => f.toLowerCase() === "invite_link");
}

/**
 * Will the send path populate {{invite_link}} with a WORKING link for this flight?
 * True when the effective offer is a $0 placeholder bound to an event whose
 * registration_mode is 'invite_gated' (personalized tokenized link) OR 'open' (the
 * same ungated /register/<id> link — the send path injects it for open mode too).
 * Mirrors send-campaign-flight exactly, so the UI never blocks a flight the send path
 * would populate, and never green-lights one it would blast with an empty link.
 */
export function willTokenizeInviteLink(
  offer:
    | { is_placeholder?: boolean | null; event_id?: string | null }
    | null
    | undefined,
  provisioning: { registration_mode?: string | null } | null | undefined,
): boolean {
  if (offer?.is_placeholder !== true || !offer?.event_id) {
    return false;
  }
  const mode = provisioning?.registration_mode;
  return mode === "invite_gated" || mode === "open";
}
